import { Amplify } from 'aws-amplify';
import config from './amplifyconfiguration.json';
Amplify.configure(config);

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { ProvideAuth } from './hooks/useAuth';
import { PostHogProvider } from 'posthog-js/react'
import { ChunkErrorBoundary } from './ChunkErrorBoundary';

const apiKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const apiHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;
const options = {
  api_host: apiHost,
  capture_pageview: 'history_change', autocapture: false
};

window.addEventListener('error', (e) => {
  const error = e?.error;
  if (error && error.name === 'ChunkLoadError') {
    console.warn('ChunkLoadError detectado. Recarregando app...');
    window.location.reload();
  }
});

window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.name === 'ChunkLoadError') {
    console.warn('ChunkLoadError detectado (Promise). Recarregando app...');
    window.location.reload();
  }
});


ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ChunkErrorBoundary>
      <PostHogProvider
        apiKey={apiKey}
        options={options}
      >
        <ProvideAuth>
          <App/>
        </ProvideAuth>
      </PostHogProvider>
    </ChunkErrorBoundary>
  </React.StrictMode>
)
